import React, { useState, useEffect } from 'react'

import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'
import ptBRLocale from 'date-fns/locale/pt-BR'

const DatePicker = (props: any) => {
  // Process the initial value
  const processDateValue = (value: any) => {
    if (!value) return null

    // If it's already a Date object, use it
    if (value instanceof Date && !isNaN(value.getTime())) {
      return value
    }

    // If it's a string, try to parse it
    if (typeof value === 'string') {
      try {
        const parsedDate = new Date(value)
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate
        }
      } catch (e) {
        console.error('Failed to parse date:', value)
      }
    }

    return null
  }

  // Initialize date from props.value if available
  const [date, setDate] = useState(processDateValue(props.value))

  // Update local state when props.value changes
  useEffect(() => {
    setDate(processDateValue(props.value))
  }, [props.value])

  // Get the locale from the column definition if available
  const locale = props.columnDef?.dateSetting?.locale === 'pt-BR' ? ptBRLocale : undefined

  return (
    <>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
        <KeyboardDatePicker
          margin="normal"
          id="date-picker-dialog"
          label="Selecione uma Data"
          format="dd/MM/yyyy"
          clearable
          value={date}
          onChange={(event: any) => {
            // Only update if the date is valid or null (cleared)
            if (event === null || (event instanceof Date && !isNaN(event.getTime()))) {
              setDate(event)
              props.onFilterChanged(props.columnDef.tableData.id, event)
            }
          }}
          KeyboardButtonProps={{
            'aria-label': 'change date'
          }}
          // Ensure the date picker displays properly
          invalidDateMessage="Data inválida"
          maxDateMessage="Data não pode ser maior que a data máxima"
          minDateMessage="Data não pode ser menor que a data mínima"
        />
      </MuiPickersUtilsProvider>
    </>
  )
}

DatePicker.displayName = 'CustomDatePicker'

export default DatePicker
